<template>
  <el-dialog :append-to-body="true" title="选择产品" :visible="visible" width="1160px" @close="$emit('close')">
    <el-form ref="queryForm" inline class="search-form" label-width="80px">
      <el-form-item label="搜索条件">
        <div style="display: grid;grid-template-columns: 120px 212px 240px;">
          <el-form-item label="" label-width="0" prop="searchType">
            <el-select v-model="searchType" style="width: 120px;" placeholder="请选择">
              <el-option label="生产信息" value="taskValue"></el-option>
              <el-option label="产品信息" value="productValue"></el-option>
              <el-option label="物料信息" value="materialValue"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="" label-width="0" prop="searchValue">
            <el-input v-model.trim="searchValue" :placeholder="autoPlaceholder" clearable style="width: 200px">
            </el-input>
          </el-form-item>
          <div>
            <el-button size="mini" type="primary" @click="handleSearch">
              搜索
            </el-button>
            <el-button size="mini" type="primary" @click="reset">
              重置
            </el-button>
          </div>
        </div>
      </el-form-item>
    </el-form>

    <el-table ref="table" height="500" :data="udiDataList" style="width: 100%; margin-top: 12px" border stripe>
      <el-table-column label="" width="45" prop="">
        <template slot-scope="scope">
          <el-radio v-model="radio" :label="scope.row.materialCode + scope.row.taskId" @change="handleSelect(scope.row)">
            {{ '' }}
          </el-radio>
        </template>
      </el-table-column>
      <el-table-column prop="taskName" label="生产任务" width="150" show-overflow-tooltip />
      <el-table-column prop="batchNumber" label="批号" width="150" show-overflow-tooltip />
      <el-table-column prop="materialName" min-width="160" label="物料名称" show-overflow-tooltip />
      <el-table-column prop="specification" min-width="120" label="物料规格型号" show-overflow-tooltip />
      <el-table-column prop="productName" min-width="160" label="产品名称" show-overflow-tooltip />
      <el-table-column prop="productSpecification" min-width="120" label="产品规格型号" show-overflow-tooltip />
      <el-table-column prop="diCode" label="DI" width="150" show-overflow-tooltip />
      <el-table-column prop="packLevel" label="包装单位" min-width="160" show-overflow-tooltip />
      <el-table-column prop="materialCode" label="物料编码" width="105" show-overflow-tooltip />
      <el-table-column prop="prodDate" label="生产日期" width="150" show-overflow-tooltip>
        <template slot-scope="scope">
          {{ scope.row.prodDate ? formatDate(scope.row.prodDate, 'yyyy-MM-dd') : null }}
        </template>
      </el-table-column>
      <el-table-column prop="expiryDate" label="失效日期" width="150" show-overflow-tooltip>
        <template slot-scope="scope">
          {{ scope.row.expiryDate ? formatDate(scope.row.expiryDate, 'yyyy-MM-dd') : null }}
        </template>
      </el-table-column>
    </el-table>
    <pagination v-show="total > 0" style="margin-top: 24px" :total="total" :page-sizes="[10,50, 100, 300]"
      :page.sync="queryParams.pageNum" :limit.sync="queryParams.pageSize" @pagination="getList" />
    <span slot="footer" class="dialog-footer">
      <el-button @click="$emit('close')">取 消</el-button>
      <el-button type="primary" @click="handleOk"> 确 定 </el-button>
    </span>
  </el-dialog>
</template>

<script>
import { getWareHousingProduct } from '@/api/warehousingOrder'
// import { getDict } from '@/api/common/index'
import { formatDate } from '@/utils/date.js'

export default {
  name: 'ProductSelect',
  props: {
    loading: {
      type: Boolean,
      default: () => {
        return false
      }
    },
    productList: {
      type: Array,
      default: () => {
        return []
      }
    },
    visible: {
      type: Boolean,
      default: () => {
        return false
      }
    }
  },
  data: () => {
    return {
      total: 0,
      formatDate,
      selection: null,
      radio: null,
      udiDataList: [],
      searchType: 'taskValue',
      searchValue: null,
      queryParams: {
        pageNum: 1,
        pageSize: 10,
      },
    }
  },
  computed: {
    autoPlaceholder() {
      switch (this.searchType) {
        case 'taskValue':
          return '任务名称/批号/产品名称/规格型号'
        case 'productValue':
          return '产品名称/规格型号/DI码'
        default:
          return '物料编码'
      }
    }
  },
  mounted() {
    if (this.productList[0]) {
      this.searchType = 'taskValue'
      this.searchValue = this.productList[0].productName
    }
    this.getList()
  },
  methods: {
    handleOk() {
      if (!this.selection) {
        this.$message.error('请选择产品')
        return
      }
      this.$emit('getData', this.selection)
    },
    // 搜索按钮点击
    handleSearch() {
      this.queryParams.pageNum = 1
      this.getList()
    },
    /**
     * @description: 处理勾选
     * @return {*}
     */
    handleSelect(val) {
      this.selection = val
      this.radio = val.materialCode + val.taskId
    },
    /**
     * @description: 重置筛选条件
     * @return {*}
     */
    reset() {
      this.queryParams = Object.assign(
        this.$data.queryParams,
        this.$options.data.call(this)
      ).queryParams
      this.searchType = 'taskValue'
      this.searchValue = null
      this.getList()
    },
    // 获取列表数据
    getList() {
      // 获取生产任务列表数据
      this.$emit('update:loading', true) // 打开遮罩
      const params = JSON.parse(JSON.stringify(this.queryParams))
      params[this.searchType] = this.searchValue
      getWareHousingProduct(params)
        .then((res) => {
          this.udiDataList = res.rows
          this.total = res.total
        })
        .finally(() => {
          this.$emit('update:loading', false) // 关闭遮罩
        })
    }
  }
}
</script>

<style scoped>
.tips {
  margin-bottom: 12px;
  font-size: 14px;
  color: #fa8c16;
}
</style>
